import React, { useContext } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import { Breadcrumb, Button, Menu } from "antd";
import { HomeOutlined } from "@ant-design/icons";

import { UserContext } from "../../../../contexts/UserContext";

import { urls, USER_ROLES } from "../../../../utils";
import { AtendimentoTabela } from "../../components/AtendimentoTabela";

const AtendimentosMunicipio = () => {
  const { user } = useContext(UserContext);

  const menuBreadcrump = (
    <Menu>
      {user?.authorities?.includes(USER_ROLES.CONSULTAR_TODAS_DENUNCIAS) ? (
        <>
          <Menu.Item>
            <Link to={urls.ATENDIMENTO_GERAL_LIST}>geral</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to={urls.ATENDIMENTO_LIST}>status</Link>
          </Menu.Item>
        </>
      ) : (
        <Menu.Item>
          <Link to={urls.ATENDIMENTO_LIST}>
            {user?.nome_instituicao?.toLowerCase()}
          </Link>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <div id="sectionMain">
      <Breadcrumb id="breadcrumb">
        <Breadcrumb.Item key="home">
          <Link to="">
            <HomeOutlined />
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="registros">registros</Breadcrumb.Item>
        <Breadcrumb.Item key="atendimentos">atendimentos</Breadcrumb.Item>
        <Breadcrumb.Item key="atendimentos" overlay={menuBreadcrump}>
          <strong>{user?.nome_municipio_instituicao?.toLowerCase()}</strong>
        </Breadcrumb.Item>
      </Breadcrumb>

      <div>
        <div className="container-section">
          <div id="header-container">
            <div>
              <h2>
                LISTA DE ATENDIMENTOS DE{" "}
                {user?.nome_municipio_instituicao?.toUpperCase()}
              </h2>
              <span>
                atualizado às {moment().format("HH:mm")} do dia{" "}
                {moment().format("DD/MM/YYYY")}
              </span>
            </div>

            <div id="header-actions">
              {user?.authorities?.includes(USER_ROLES.INCLUIR_DENUNCIA) && (
                <Link to={urls.ATENDIMENTO_CRIAR} className="button-link">
                  <Button type="primary" style={{ width: "160px" }}>
                    novo atendimento
                  </Button>
                </Link>
              )}
            </div>
          </div>
          <AtendimentoTabela
            showStatus
            showBairro
            municipioFilter={false}
            filtro={{
              cidadeIdList: [user?.codigo_municipio_instituicao],
            }}
            tipoRegistro="ATENDIMENTO"
          />
        </div>
      </div>
    </div>
  );
};

export default AtendimentosMunicipio;
